import { reportMessageToSentry } from "@coworker/app/src/hooks/useConfigureSentry";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";
import ViewerTopFragmentConfig from "./ViewerTopFragmentConfig";
import MultipleArticlesViewerTopFragment from "../MultipleArticlesViewerTopFragment/MultipleArticlesViewerTopFragment";

export type ViewerTopFragmentCommonProps = {
  task: Record<string, unknown> | Loading;
};

type ViewerTopFragmentProps = {
  config: ViewerTopFragmentConfig;
  commonProps: ViewerTopFragmentCommonProps;
};

function ViewerTopFragment({ config, commonProps }: ViewerTopFragmentProps) {
  const { id, props: configProps } = config;
  switch (id) {
    case "multiple-articles-viewer-top-fragment": {
      return (
        <MultipleArticlesViewerTopFragment
          commonProps={commonProps}
          configProps={configProps}
        />
      );
    }
    default: {
      console.error(
        `'${id}' does not map to any viewer top fragment component`
      );
      reportMessageToSentry(
        `Viewer top fragment config id does not map to any viewer top fragment component`,
        {
          id,
        },
        "error"
      );
      return null;
    }
  }
}

export default ViewerTopFragment;
